import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const trendingPosts = [
  {
    slug: "how-mounjaro-works",
    image: "/images/trends/blog1.png",
    title: "How Mounjaro Works: A Deep Dive into GIP/GLP-1",
    category: "SCIENCE",
    excerpt: "Understand the dual-agonist mechanism that makes Mounjaro a breakthrough treatment.",
  },
  {
    slug: "starting-your-journey",
    image: "/images/trends/blog2.png",
    title: "Starting Your Mounjaro Journey: What to Expect",
    category: "GETTING STARTED",
    excerpt: "From your first injection to week 12: a guide to the early stages of treatment.",
  },
  {
    slug: "managing-side-effects",
    image: "/images/trends/blog3.png",
    title: "Managing Common Side Effects of Mounjaro",
    category: "HEALTH TIPS",
    excerpt: "Practical tips to minimize nausea, fatigue, and other common side effects.",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

function TrendingSection() {
  return (
    <section className="bg-gray-100 px-6 md:px-20 py-12 md:py-16">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
        <h2 className="text-3xl md:text-5xl font-bold text-black mb-6 md:mb-0">
          What's trending
        </h2>
        <button className="hidden md:flex items-center group">
          <span className="text-sm px-5 py-2 bg-gray-200 rounded-full shadow-sm transition-colors group-hover:bg-gray-300">
            What's trending
          </span>
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-200 transition-colors group-hover:bg-gray-300 ml-2">
            <svg
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-gray-700"
              viewBox="0 0 24 24"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </div>
        </button>
      </div>
      <motion.div
        className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left mb-8 md:mb-0"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {trendingPosts.map((post, index) => (
          <Link to={`/blog/${post.slug}`} key={index} className="block">
            <motion.div
              className="group cursor-pointer"
              variants={itemVariants}
            >
              <div className="overflow-hidden">
                <motion.img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-auto object-cover"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                />
              </div>
              <h3 className="font-semibold text-lg mt-4 group-hover:text-black transition-colors duration-300">
                {post.title}
              </h3>
              <p className="text-xs text-gray-500 mt-2">{post.category}</p>
            </motion.div>
          </Link>
        ))}
      </motion.div>
      <button className="flex md:hidden items-center group w-full justify-center">
        <span className="text-sm px-5 py-2 bg-gray-200 rounded-full shadow-sm transition-colors group-hover:bg-gray-300">
          What's trending
        </span>
        <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-200 transition-colors group-hover:bg-gray-300 ml-2">
          <svg
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-gray-700"
            viewBox="0 0 24 24"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </div>
      </button>
    </section>
  );
}

export default TrendingSection;
